import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { environment } from '../environments/environment';
import { Language } from './constants/supportedLanguages';
import { LocalStorageService } from '@services/local-storage/local-storage.service';
import { firstValueFrom } from 'rxjs/internal/firstValueFrom';

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
    return new TranslateHttpLoader(http);
}

export function appInitializerFactory(translate: TranslateService, localStorageService: LocalStorageService) {
    return async () => {
        translate.setDefaultLang('en');
        const lang: Language = localStorageService.getItem('language');
        let langCode: string;

        if (lang) {
            langCode = lang.language_code;
        } else {
            // Overwriting Bokmål "nb" or Nynorsk "nn" to Norsk "no"
            if (window.navigator.language.substring(0, 2) === 'nb' || window.navigator.language.substring(0, 2) === 'nn') {
                langCode = 'no';
            } else if (environment.locals.includes(window.navigator.language.substring(0, 2))) {
                langCode = window.navigator.language.substring(0, 2);
            } else {
                langCode = 'en';
            }
        }

        try {
            // Wait for translations to load
            await firstValueFrom(translate.use(langCode));
        } catch (error) {
            console.error(`Failed to load translations for '${langCode}'`, error);
            // Fall back to English if there was an error
            await firstValueFrom(translate.use('en'));
        }
    };
}
